export const c_popover_MaxWidth = {
  "name": "--pf-v6-c-popover--MaxWidth",
  "value": "none",
  "var": "var(--pf-v6-c-popover--MaxWidth)"
};
export default c_popover_MaxWidth;